import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const EventDetailSlice = createSlice({
    name: "eventDetail",
    initialState,
    reducers: {
        getEventDetailRequest(state) {
            state.loading = true;
        },
        getEventDetailRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getEventDetailRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getEventDetailRequest,
    getEventDetailRequestSuccess,
    getEventDetailRequestError,
} = EventDetailSlice.actions;

export default EventDetailSlice.reducer;
